module.exports = __webpack_public_path__ + "static/media/step9.51481c38.png";